import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

export default class ArtistFunctionRelationModel extends Model {
  @attr('boolean') mainFunction;
  @attr('number') position;

  // Relations
  @belongsTo('artist', { async: true, inverse: 'artistFunctions' }) artist;
  @belongsTo('category', { async: true, inverse: null }) category;
}
